import { useAuth } from "@/app/providers/AuthProvider";
import { SYSTEM_ROLES } from "@carmel/shared";
import { useCapabilities } from "./useCapabilities";

const ADMIN_ROLES: readonly string[] = [SYSTEM_ROLES.SUPERADMIN, SYSTEM_ROLES.ADMIN];

/**
 * Legacy permission hook — maintained for backward compatibility.
 * New code should use useCapabilities() instead.
 */
export function usePermission() {
  const { user } = useAuth();
  const capabilities = useCapabilities();

  const isAdmin = user ? ADMIN_ROLES.includes(user.role) : false;
  const isSuperAdmin = user?.role === SYSTEM_ROLES.SUPERADMIN;
  const isManagement = user?.role === SYSTEM_ROLES.MANAGEMENT;

  const hasRole = (roles: string[]) => user ? roles.includes(user.role) : false;

  const canManage = isAdmin;
  const canDelete = isAdmin;

  return {
    // Legacy fields
    isAdmin,
    isSuperAdmin,
    isManagement,
    hasRole,
    canManage,
    canDelete,
    // New capability-based fields
    capabilities: capabilities.capabilities,
    roleKey: capabilities.roleKey,
    departmentId: capabilities.departmentId,
    hasCapability: capabilities.hasCapability,
    canViewOversight: capabilities.canViewOversight,
    canViewDepartmentDashboard: capabilities.canViewDepartmentDashboard,
    isDepartmentHead: capabilities.isDepartmentHead,
  };
}
